import Button from "@mui/material/Button";
import { useGoogleLogin } from "@react-oauth/google";
import { useState, useEffect } from "react";
import FingerprintJS from "@fingerprintjs/fingerprintjs";
import axios from "../../api/axios";
import { googleButtonStyleSX } from "./containerComponents/styles";
import TextStrings from "~/src/components/base/strings";

const handleSocialLogin = async (authData, setError, fpHash) => {
  try {
    const response = await axios.post(
      "/rest-auth/google/login/",
      JSON.stringify({
        access_token: authData.access_token,
        provider: "google",
        fingerprint: fpHash,
      }),
      {
        withCredentials: true,
        headers: {
          "Content-Type": "application/json",
        },
      }
    );

    if (response.data.key) {
      console.log("Google Auth: Login successful:", response.data);
      window.location.href = "/app/pl/menu";
    } else {
      console.error("Google Auth: Login failed:", response.data);
      setError(TextStrings.errors.googleAuthError);
    }
  } catch (error) {
    console.error("Error during google login:", error);
    setError(TextStrings.errors.googleAuthError);
  }
};

const GoogleButton = () => {
  const [error, setError] = useState("");
  const [fpHash, setFpHash] = useState("");
  const login = useGoogleLogin({
    onSuccess: (authData) => handleSocialLogin(authData, setError, fpHash),
    onError: (error) => {
      console.log("Google Auth: User authentication failed:", error);
      setError(TextStrings.errors.googleAuthError);
    },
  });

  useEffect(() => {
    const setFp = async () => {
      const fp = await FingerprintJS.load();

      const { visitorId } = await fp.get();

      setFpHash(visitorId);
    };

    setFp();
  }, []);

  return (
    <>
      <div
        className="cx-error-message-email"
        style={{ color: "red", display: error ? "block" : "none" }}
      >
        {error}
      </div>
      <Button
        onClick={() => login()}
        variant="contained"
        sx={googleButtonStyleSX}
      >
        <i className="fa-brands fa-google"></i>
      </Button>
    </>
  );
};

export default GoogleButton;
